var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tick-flash",class:{
    'cell-flash-green': _vm.isPositive && _vm.isFullCell,
    'cell-flash-red': _vm.isNegative && _vm.isFullCell,
    'text-flash-green': _vm.isPositive && _vm.isTextOnly,
    'text-flash-red': _vm.isNegative && _vm.isTextOnly
  }},[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }